module.exports = __webpack_public_path__ + "static/media/Herica_Pes.4b09098d.jpg";